export class OutagesResponse {
    resultCount: number;
    limit: number;
    offset: number;
    sortBy: string;
    sortOrder: string;
    results?: (OutagesBasicInfo)[] | null;
}

export class OutagesBasicInfo {
    itemId: number;
    itemName: string;
    categoryName: string;
    itemTypeName: string;
    itemStatus: string;
    inactiveTime: string;
    isServiceItem: boolean;
}
